

/** 
 * Informações para os campos do form
 * @type {{
 *   groups: Array<{
 *      header: string,
 *      fields: Array<{
 *        label: string,
 *        placeholder: string,
 *        name: string,
 *        type: string,
 *        size: number,
 *        className: string
 *      }>
 *   }
 * }>} 
*/
export const getFormFields = () => {
    return {
        groups: [
            /* {
                header: '',
                shouldRender: (form) => {
                    return !['', null, undefined].includes(form.cod);
                },
                fields: [
                    {
                        label: 'Código',
                        placeholder: '',
                        name: 'cod',
                        type: 'text',
                        size: 3,
                        readOnly: true,
                        // hidden: true,
                    },
                ]
            }, */
            {
                fields: [
                    {
                        label: 'Sigla',
                        placeholder: 'Ex:',
                        name: 'sigla',
                        type: 'text',
                        size: 4,
                        max: 10,
                        readOnly: true
                    },
                    {
                        label: 'Nome',
                        placeholder: '',
                        name: 'nome',
                        type: 'text',
                        size: 8,
                        max: 60,
                        readOnly: true
                    }
                ]
            },
            {
                header: 'Valores Padrões', 
                fields: [
                    {
                        label: 'Valor Custo Padrão',
                        placeholder: '',
                        name: 'valor',
                        type: 'currency',
                        size: 4,
                        readOnly: true,
                        defaultValue: 0
                    },
                    {
                        label: 'Período do Valor',
                        placeholder: '',
                        name: 'periodoValor',
                        type: 'select',
                        options: [
                            { label: '...' },
                            { label: 'Diário', value: 'dia' },
                            { label: 'Mensal', value: 'mes' },
                        ],
                        size: 3,
                        readOnly: true,
                    },
                    {
                        label: 'Base Aliq.Desconto',
                        placeholder: '',
                        name: 'baseAliqDesc',
                        type: 'select',
                        options: [
                            { label: 'Custo Adicional', value: 'beneficio' },
                            { label: 'Salário', value: 'salario' },
                        ],
                        size: 3,
                        readOnly: true,
                    }
                ]
            }
        ]
    };
}

const BeneficioColabFormInfo = { getFormFields };

export default BeneficioColabFormInfo;
